import {UPDATE_ZIP} from "../actions/actions";

import JSZip from 'jszip';

const filesReducer = (state = new JSZip(), action) => {
    switch (action.type) {
        case UPDATE_ZIP:
            return action.zipObj;
        default:
            return state;
    }
};

export default filesReducer;


// WEBPACK FOOTER //
// ./src/app/reducers/filesReducer.js